import {
  AutocompleteInput,
  Datagrid,
  EditButton,
  FileField,
  Filter,
  RadioButtonGroupInput,
  ReferenceInput,
  SelectInput,
  TextField,
  TextInput,
} from 'react-admin'

import {
  FUEL_RECEIPT_REPORT_LINK,
  IFTA_CHOICES,
  MAX_NUM_TEAMS,
  QUARTER_CHOICES,
} from '../../helpers/constants'
import { US_STATES } from '../../helpers/states'
import { CustomDateField } from '../Fields'
import CTList from '../List'

const teamTextRenderer = (team: any) => {
  const is_approved = team && team.is_approved ? 'APPROVED' : 'DEACTIVATED'
  return (
    team &&
    team.product_subscription &&
    `${team.name}  (${is_approved}, ${team.product_subscription.product_name})`
  )
}

const FuelFilter = (props: any) => (
  <Filter {...props}>
    <SelectInput
      label="Quarter"
      source="quarter_year"
      choices={QUARTER_CHOICES}
      emptyText={'All quarters'}
      alwaysOn
    />
    <ReferenceInput
      label="Team"
      source="team"
      reference="teams"
      filterToQuery={(searchText) => ({ search: searchText })}
      sort={{ field: 'name', order: 'ASC' }}
      filter={{ is_real: true }}
      allowEmpty={true}
      emptyText={'All teams'}
      perPage={MAX_NUM_TEAMS}
      alwaysOn
    >
      <AutocompleteInput optionText={teamTextRenderer} fullWidth={true} />
    </ReferenceInput>
    <SelectInput
      source="jurisdiction"
      label="Purchase State"
      choices={US_STATES}
      optionText="abbreviation"
      optionValue="abbreviation"
      emptyText={'All states'}
      alwaysOn
    />
    <RadioButtonGroupInput label="" source="ifta" choices={IFTA_CHOICES} alwaysOn />
    <TextInput optionText="Search by VIN, Reported by, Jurisdiction" source="search" alwaysOn />
  </Filter>
)

const FuelFilterDefaultValue = { ifta: 'False', quarter_year: QUARTER_CHOICES[0]['id'] }

const exporter = () => {
  window.open(FUEL_RECEIPT_REPORT_LINK, '_blank')
}

const FuelList = (props: any) => (
  <CTList
    bulkActionButtons={false}
    filters={<FuelFilter />}
    filterDefaultValues={FuelFilterDefaultValue}
    exporter={exporter}
    {...props}
  >
    <Datagrid optimized rowClick="edit">
      <CustomDateField source="date_purchased" />
      <CustomDateField source="date_submitted" />
      <TextField source="truck.vin_number" label="Vehicle(VIN)" />
      <TextField source="truck.license_plate_number" label="Truck plate" />
      <TextField source="truck.ifta_sticker_number" label="IFTA Number" />
      <TextField source="jurisdiction" />
      <TextField source="reported_by.full_name" label="Reported by" />
      <TextField source="price_per_gallon" />
      <TextField source="total_gallons" />
      <FileField source="fuel_attachment[0].fuel_receipt_attachment" label="Receipt" title="View file" />
      <EditButton />
    </Datagrid>
  </CTList>
)

export default FuelList
